function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFooterLogoMobile = function SvgFooterLogoMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width,
    height: props.height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: props.viewBox
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#footer-logo-mobile_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.968 24.966H24.97v19.407h75.288v6.22H19.421V19.407h99.335V0H9.711C4.348 0 0 4.344 0 9.704v50.592C0 65.656 4.348 70 9.71 70h100.258c5.363 0 9.711-4.344 9.711-9.704V34.67c0-5.36-4.348-9.703-9.711-9.703Z",
    fill: props.color,
    stroke: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "M0 0h19.351v19.356H0z",
    stroke: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.797 4.257 12.04 6.022 10.274 7.78 8.514 9.545l1.032 1.025 1.758-1.758.734.733-2.5 2.492-2.492-2.492 3.524-3.523L9.54 4.991 5.504 9.033v1.025l3.523 3.523h1.025l3.524-3.523V9.033L12.329 7.78l.734-.733 2.5 2.498-6.023 6.023-6.016-6.023L9.54 3.523l1.765 1.765 1.024-1.031-2.27-2.277H9.027L1.98 9.033v1.025l7.047 7.046h1.025l7.047-7.046V9.033l-3.004-3.01.734-.735 4.257 4.257-9.546 9.546L0 9.545 9.547 0l4.25 4.257ZM124.85 9.717v60.284h19.421V44.373h99.879V24.966h-99.879V19.42h99.879V.014H134.56c-5.363 0-9.71 4.344-9.71 9.703ZM359.289 31.897c5.363 0 9.711-4.344 9.711-9.704V.013h-19.421V12.49H269.12V.014h-19.421v22.18c0 5.359 4.348 9.703 9.711 9.703h40.229v5.545H259.41c-5.363 0-9.711 4.344-9.711 9.704V70h19.421V56.849h80.459v13.152H369V47.145c0-5.36-4.348-9.704-9.711-9.704H319.06v-5.545h40.229Z",
    fill: props.color,
    stroke: props.color
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "footer-logo-mobile_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "M0 0h369v70H0z",
    stroke: props.color
  }))));
};
export default SvgFooterLogoMobile;